"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshInterceptor = void 0;
const isAuthError_1 = require("../../../../helpers/isAuthError");
const isLoginError_1 = require("../../../../helpers/isLoginError");
const isRefreshError_1 = require("../../../../helpers/isRefreshError");
const refreshInterceptor = (api, refreshLogic, refreshFailedCallback) => async (error) => {
    const originalRequest = error.config;
    // Don't retry refresh or login requests
    if (error.config && ((0, isLoginError_1.isLoginError)(error.config.url) || (0, isRefreshError_1.isRefreshError)(error.config.url))) {
        return Promise.reject(error);
    }
    // If 401 error and we haven't tried refreshing yet
    if ((0, isAuthError_1.isAuthError)(error?.response?.status) && !originalRequest._retry) {
        originalRequest._retry = true;
        try {
            // Attempt to refresh the token
            await refreshLogic();
            // Retry the original request with the new token
            return api(originalRequest);
        }
        catch (refreshError) {
            // If refresh failed, trigger logout
            refreshFailedCallback();
            return Promise.reject(refreshError);
        }
    }
    // Handle specific session not active message (fallback)
    if (error?.response?.status === 401 && error.response.data?.message === 'Session is not active') {
        refreshFailedCallback();
    }
    return Promise.reject(error);
};
exports.refreshInterceptor = refreshInterceptor;
